import { ref, computed } from 'vue';
import CSATReportsAPI from 'dashboard/api/csatReports';
import SLAReportsAPI from 'dashboard/api/slaReports';
import TeamsAPI from 'dashboard/api/teams';

// CSAT, SLA e Times so aparecem na casa para conta que usa.
//
// O sinal e o mais barato que ja existe: o endpoint `metrics` de cada um, que
// devolve um agregado (nao a lista). Medido em 19/09/2026, producao e staging:
// ZERO linhas nas duas tabelas em todas as contas. Sem esse gate, duas abas
// permanentes mostrariam "0 respostas" e "100% de acerto" para todo mundo.
//
// SiteUP CRM (relatorios r2, item E): Times entra na MESMA regra. Medido em
// 19/09/2026: 1 time em toda a base, e 0% das conversas das 5 maiores contas
// tem time. A aba mostrava uma tabela vazia para 15 das 16 contas. O sinal aqui
// e a lista de times da conta, que a casa ja carrega de qualquer forma.
//
// Uma chamada por conta por sessao: o resultado fica no cache do modulo. Erro
// NAO vira "nao usa": fica indefinido, a aba nao aparece e a rota direta
// continua abrindo (deep link antigo nao quebra). Erro nunca vira zero.

const cache = new Map();

const probeAccount = () => {
  const params = { from: 0, to: Math.floor(Date.now() / 1000) };

  const csat = CSATReportsAPI.getMetrics(params)
    .then(response => Number(response?.data?.total_count || 0) > 0)
    .catch(() => undefined);

  const sla = SLAReportsAPI.getMetrics(params)
    .then(response => Number(response?.data?.total_applied_slas || 0) > 0)
    .catch(() => undefined);

  const teams = TeamsAPI.get()
    .then(response => (response?.data?.length || 0) > 0)
    .catch(() => undefined);

  return Promise.all([csat, sla, teams]).then(
    ([csatUsed, slaUsed, teamsUsed]) => ({
      csat: csatUsed,
      sla: slaUsed,
      teams: teamsUsed,
    })
  );
};

/** Limpa o cache. Existe para o teste; em producao a sessao mede uma vez. */
export const resetReportsUsageCache = () => cache.clear();

/**
 * @param {import('vue').Ref<number>|{ value: number }} accountId
 * @returns {{ usage: import('vue').ComputedRef<{csat?: boolean, sla?: boolean, teams?: boolean}> }}
 */
export function useReportsUsage(accountId) {
  const usage = ref({});

  const load = id => {
    if (!id) return;
    if (!cache.has(id)) cache.set(id, probeAccount());
    cache.get(id).then(result => {
      if (Number(accountId?.value) === Number(id)) usage.value = result;
    });
  };

  load(Number(accountId?.value));

  return { usage: computed(() => usage.value), reload: load };
}
